export default __webpack_public_path__ + "static/media/coverphoto-opaque1.b10c5813.png";